import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { NucleusIdentityService } from './NucleusIdentityService';
import { NucleusIdentityConfig } from './NucleusIdentityConfig';

@Injectable()
export class NucleusTokenInterceptor implements HttpInterceptor {
  constructor(private auth: NucleusIdentityService, private config: NucleusIdentityConfig
  ) { }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.shouldIntercept(req.url)) {
      var res: Observable<HttpEvent<any>>;
      if (this.auth.isAuthenticated) {
        res = from(this.authorizeRequest(req, next))
      } else {
        res = next.handle(req)
      }
      return this.checkUnauthorized(res);
    } else {
      return next.handle(req);
    }
  }

  private shouldIntercept(url: string): boolean {
    if (!this.config.httpInterceptorUrls) {
      return false;
    }

    url = url.toLowerCase();
    if (url.includes("/connect/") || url.includes(".well-known/openid-configuration")) { //TODO: prevent intercept for oidc endpoints / we need better way
      return false;
    }

    return this.config.httpInterceptorUrls.some(x => url.startsWith(x.toLocaleLowerCase()))
  }

  private async authorizeRequest(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    var token = await this.auth.getAccessToken();
    const headers = req.headers.set('Authorization', `Bearer ${token}`);
    req = req.clone({ headers });
    return next.handle(req).toPromise();
  }

  private checkUnauthorized(response : Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    response.toPromise().catch(err => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        this.auth.logout();
        if (this.config.automaticLoginOnHttp401) {
          this.auth.login();
        }
      }
    });

    return response;
  }

}
